import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise-middleware';

import content from './content';
import stamps from './stamps';

const configureStore = function() {
    const initialState = {};
    const reducers = {
        content,
        stamps,
    };
    const reduxPersistConfig = {
        key: 'acic',
        storage,
        blacklist: 'form'
    };
    const rootReducer = persistCombineReducers(reduxPersistConfig, reducers);

    const enhancer = applyMiddleware(promise);
    const store = createStore(rootReducer, initialState, enhancer);
    const persistor = persistStore(store);
    return { persistor, store };
}

const { persistor, store } = configureStore();

export {store, persistor};
